module.exports = {"name":"Detail páru","icon":"<i class='material-icons'>people</i>","widget":[{"type":"detail","initData":{},"api":{"url":"couples/detail","id":"coupleId"},"groups":[{"title":"Osobne udaje","fields":[["Meno","baseData.name.v"],["Priezvisko","baseData.surName.v"],["Rodne meno","baseData.bornName"],["Pohlavie","baseData.gender"],["Narodnost","baseData.nationality"]]},{"title":"Kontakt","showIf":"contactInfo","fields":[["Ulica","contactInfo.street"],["Mesto","contactInfo.city"],["PSC","contactInfo.zipCode"]]}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/couples-detail/couples-detail.json
// module id = 322
// module chunks = 0